
import request from '@/utils/request'
import axios from "axios";

/**
 * @param {*} data
 * @returns
 */
export function getTypicalUsers(data) {
  return request({
    url: '/typicalUsers/web/getTypicalUsers',
    method: 'POST',
    data: data
  })
}

/**
 * @param {*} data
 * @returns
 */
export function getTypicalUserTypes(data) {
  return request({
    url: '/typicalUsers/web/getTypicalUserTypes',
    method: 'POST',
    data: data
  })
}


export function getTypicalUsersFromJsonFile(data) {
  let typicalUsersTypeUrl = window.location.origin + '/jx/images/platform/homepage/typicalUsers/typicalUsers.json';
  axios.get(typicalUsersTypeUrl)
    .then(response => {
      debugger;
      this.jsonData = response.data; // 将获取的数据赋值给jsonData
    })
    .catch(error => {
      console.error('There was an error!', error);
    });
}



export function getTypicalUserTypesFromJsonFile(data) {
  let typicalUsersTypeUrl = window.location.origin + '/jx/images/platform/homepage/typicalUsers/typicalUsersType.json';
  axios.get(typicalUsersTypeUrl)
    .then(response => {
      debugger;
      this.jsonData = response.data; // 将获取的数据赋值给jsonData
    })
    .catch(error => {
      console.error('There was an error!', error);
    });
}
